import * as React from "react";

//React router dom
import { Route, Routes } from "react-router-dom";

//Context
import { TimeContext, timeConfigs } from "../../config/time";

import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";

//Selfmade components
import Navbar from "../../components/navigation/navbar";
import Dashboard from "./dashboard";
import EmbedViewer from "./embed";
import { IntersectionsTab } from "../../components/admin/intersectionsTab";
import { SegmentsTab } from "../../components/admin/segmentsTab";
import { BikeCountersTab } from "../../components/admin/bikeCountersTab";
import {useAuth} from "../../contexts/AuthContext";
import {SchedulesTab} from "../../components/admin/schedulesTab";

export default function Home() {
  const [timeConfig, setTimeConfig] = React.useState(timeConfigs.currentYear);

  const { isAuthenticated } = useAuth();

  const time = isAuthenticated ? localStorage.getItem("timeConfig") : "cyear";

  //Time effect
  React.useEffect(() => {
    switch (time) {
      case "cyear":
        setTimeConfig(timeConfigs.currentYear);
        break;

      case "lyear":
        setTimeConfig(timeConfigs.lastYear);
        break;

      default:
        setTimeConfig(timeConfigs.currentYear);
        break;
    }
  }, [time]);

  return (
    <TimeContext.Provider value={{ timeConfig, setTimeConfig }}>
      <CssBaseline />
      <Navbar />
      <Box
        component="main"
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          paddingTop: "64px",
          bgcolor: "#C1CCD2",
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              <Dashboard page={"traffic"} />
            }
          />
          <Route
            path="/maintenance"
            element={
              <Dashboard
                page={"maintenance"}
              />
            }
          />
          <Route path="/Curbside" element={<EmbedViewer />} />
          {isAuthenticated && (
            <>
              <Route
                path="/administration/intersections"
                element={<IntersectionsTab />}
              />
              <Route
                path="/administration/segments"
                element={<SegmentsTab />}
              />
              <Route
                path={"/administration/bikeCounters"}
                element={<BikeCountersTab />}
              />
              <Route
                path={"/administration/schedules"}
                element={<SchedulesTab />}
              />
            </>
          )}
        </Routes>
      </Box>
    </TimeContext.Provider>
  );
}
